var initDnShadowbox = function(images) {

    var galleryItems = [];

    var initGalleryItems = function (images) {
        var items = [];

        images.each(function () {
            item = {
                src: $(this).attr('href'),
                w: 0,
                h: 0,
            };

            items.push(item);
        });

        galleryItems = items;
    };

    var initGalleryItemsOnClick = function () {
        images.each(function (i) {
            $(this).click(function (e) {
                e.preventDefault();
                openGallery(galleryItems, i);
            });
        });
    };


    var openGallery = function (items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];

        // set options
        var options = {
            index: typeof(index) != "undefined" ? index : 0,
            arrowKeys: items.length > 1,
            closeElClasses: ['ui', 'top-bar', 'caption', 'zoom-wrap', 'item'],
            clickToCloseNonZoomable: false,
            bgOpacity: 0.90,
            zoomEl: false,
            tapToToggleControls: false,
            hideAnimationDuration:0,
            showAnimationDuration:0,
            allowPanToNext: items.length > 1,
            arrowEl: items.length > 1,
            history: false,
            galleryPIDs: false,
        };

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

        // dynamically load width and height of added images
        gallery.listen('gettingData', function (index, item) {
            if (item.w < 1 || item.h < 1) {
                var img = new Image();
                img.onload = function () {
                    item.w = this.width;
                    item.h = this.height;
                    gallery.updateSize(true);
                };
                img.src = item.src;
            }
        });

        gallery.listen('destroy', function () {
        });

        gallery.init();
    };

    initGalleryItems(images);
    initGalleryItemsOnClick(galleryItems);
};

$(document).ready(function() {

    $('.dnJs-shadowbox-container').each(function() {
        var images = $(this).find('.dnJs-shadowbox-item');
        initDnShadowbox(images);
    });

    $('.dnJs-shadowbox-single').each(function() {
        initDnShadowbox($(this));
    });
});